/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    BodyUpdateEpisodeApiV1EpisodesEpisodePut,
    EpisodeAdminModel,
    EpisodeCreateModel,
    HTTPValidationError,
    ListEpisodeAdminResponse,
    ListEpisodeResponse,
    ResponseGetEpisodeApiV1EpisodesEpisodeGet,
} from '../models/index';
import {
    BodyUpdateEpisodeApiV1EpisodesEpisodePutFromJSON,
    BodyUpdateEpisodeApiV1EpisodesEpisodePutToJSON,
    EpisodeAdminModelFromJSON,
    EpisodeAdminModelToJSON,
    EpisodeCreateModelFromJSON,
    EpisodeCreateModelToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ListEpisodeAdminResponseFromJSON,
    ListEpisodeAdminResponseToJSON,
    ListEpisodeResponseFromJSON,
    ListEpisodeResponseToJSON,
    ResponseGetEpisodeApiV1EpisodesEpisodeGetFromJSON,
    ResponseGetEpisodeApiV1EpisodesEpisodeGetToJSON,
} from '../models/index';

export interface CreateEpisodeApiV1EpisodesEpisodePostRequest {
    episodeCreateModel: EpisodeCreateModel;
}

export interface DeleteEpisodeApiV1EpisodesEpisodeDeleteRequest {
    id: string;
}

export interface GetEpisodeAdminApiV1EpisodesAdminEpisodeGetRequest {
    id: string;
}

export interface GetEpisodeApiV1EpisodesEpisodeGetRequest {
    id: string;
}

export interface GetEpisodesAdminApiV1EpisodesAdminGetRequest {
    showId: string;
    limit?: number;
    offset?: number;
}

export interface GetEpisodesApiV1EpisodesGetRequest {
    showId: string;
    limit?: number;
    offset?: number;
}

export interface UpdateEpisodeApiV1EpisodesEpisodePutRequest {
    id: string;
    bodyUpdateEpisodeApiV1EpisodesEpisodePut?: BodyUpdateEpisodeApiV1EpisodesEpisodePut;
}

/**
 *
 */
export class EpisodeApi extends runtime.BaseAPI {
    /**
     * Create an episode for a show.
     * Create Episode
     */
    async createEpisodeApiV1EpisodesEpisodePostRaw(
        requestParameters: CreateEpisodeApiV1EpisodesEpisodePostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EpisodeAdminModel>> {
        if (requestParameters['episodeCreateModel'] == null) {
            throw new runtime.RequiredError(
                'episodeCreateModel',
                'Required parameter "episodeCreateModel" was null or undefined when calling createEpisodeApiV1EpisodesEpisodePost().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/episodes/episode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EpisodeCreateModelToJSON(requestParameters['episodeCreateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            EpisodeAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Create an episode for a show.
     * Create Episode
     */
    async createEpisodeApiV1EpisodesEpisodePost(
        requestParameters: CreateEpisodeApiV1EpisodesEpisodePostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EpisodeAdminModel> {
        const response = await this.createEpisodeApiV1EpisodesEpisodePostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete an episode by its ID.
     * Delete Episode
     */
    async deleteEpisodeApiV1EpisodesEpisodeDeleteRaw(
        requestParameters: DeleteEpisodeApiV1EpisodesEpisodeDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteEpisodeApiV1EpisodesEpisodeDelete().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/episodes/episode`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete an episode by its ID.
     * Delete Episode
     */
    async deleteEpisodeApiV1EpisodesEpisodeDelete(
        requestParameters: DeleteEpisodeApiV1EpisodesEpisodeDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.deleteEpisodeApiV1EpisodesEpisodeDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve an episode by its ID (admin).
     * Get Episode Admin
     */
    async getEpisodeAdminApiV1EpisodesAdminEpisodeGetRaw(
        requestParameters: GetEpisodeAdminApiV1EpisodesAdminEpisodeGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EpisodeAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEpisodeAdminApiV1EpisodesAdminEpisodeGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/episodes/admin/episode`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            EpisodeAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve an episode by its ID (admin).
     * Get Episode Admin
     */
    async getEpisodeAdminApiV1EpisodesAdminEpisodeGet(
        requestParameters: GetEpisodeAdminApiV1EpisodesAdminEpisodeGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EpisodeAdminModel> {
        const response = await this.getEpisodeAdminApiV1EpisodesAdminEpisodeGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve an episode by its ID.
     * Get Episode
     */
    async getEpisodeApiV1EpisodesEpisodeGetRaw(
        requestParameters: GetEpisodeApiV1EpisodesEpisodeGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ResponseGetEpisodeApiV1EpisodesEpisodeGet>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEpisodeApiV1EpisodesEpisodeGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/episodes/episode`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ResponseGetEpisodeApiV1EpisodesEpisodeGetFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve an episode by its ID.
     * Get Episode
     */
    async getEpisodeApiV1EpisodesEpisodeGet(
        requestParameters: GetEpisodeApiV1EpisodesEpisodeGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ResponseGetEpisodeApiV1EpisodesEpisodeGet> {
        const response = await this.getEpisodeApiV1EpisodesEpisodeGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve all episodes for a show (admin).
     * Get Episodes Admin
     */
    async getEpisodesAdminApiV1EpisodesAdminGetRaw(
        requestParameters: GetEpisodesAdminApiV1EpisodesAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListEpisodeAdminResponse>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling getEpisodesAdminApiV1EpisodesAdminGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['showId'] != null) {
            queryParameters['show_id'] = requestParameters['showId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/episodes/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListEpisodeAdminResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve all episodes for a show (admin).
     * Get Episodes Admin
     */
    async getEpisodesAdminApiV1EpisodesAdminGet(
        requestParameters: GetEpisodesAdminApiV1EpisodesAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListEpisodeAdminResponse> {
        const response = await this.getEpisodesAdminApiV1EpisodesAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve all episodes for a show.
     * Get Episodes
     */
    async getEpisodesApiV1EpisodesGetRaw(
        requestParameters: GetEpisodesApiV1EpisodesGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListEpisodeResponse>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling getEpisodesApiV1EpisodesGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['showId'] != null) {
            queryParameters['show_id'] = requestParameters['showId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/episodes/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListEpisodeResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve all episodes for a show.
     * Get Episodes
     */
    async getEpisodesApiV1EpisodesGet(
        requestParameters: GetEpisodesApiV1EpisodesGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListEpisodeResponse> {
        const response = await this.getEpisodesApiV1EpisodesGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update an episode with the given parameters.
     * Update Episode
     */
    async updateEpisodeApiV1EpisodesEpisodePutRaw(
        requestParameters: UpdateEpisodeApiV1EpisodesEpisodePutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EpisodeAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateEpisodeApiV1EpisodesEpisodePut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/episodes/episode`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: BodyUpdateEpisodeApiV1EpisodesEpisodePutToJSON(
                    requestParameters['bodyUpdateEpisodeApiV1EpisodesEpisodePut'],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            EpisodeAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Update an episode with the given parameters.
     * Update Episode
     */
    async updateEpisodeApiV1EpisodesEpisodePut(
        requestParameters: UpdateEpisodeApiV1EpisodesEpisodePutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EpisodeAdminModel> {
        const response = await this.updateEpisodeApiV1EpisodesEpisodePutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
